import React from 'react';
import styles from './Subscription.module.scss';
import { Text, fontWeightEnum, textVariantsEnum } from '@/components/Text';
import { buttonVariants, Button } from '@/components/Button';
export const DomesticPaymentMethodWarningModal = ({ onClose, onConfirm }) => {
  return (
    <div className={styles.domesticPaymentMethodWarningModal}>
      <Text
        variant={textVariantsEnum.Text_lg}
        fontWeight={fontWeightEnum.Semibold}
      >
        Payment Method Warning
      </Text>
      <Text
        variant={textVariantsEnum.Text_md}
        fontWeight={fontWeightEnum.Normal}
      >
        Your current payment method does not support to change the subscription
        plan.
      </Text>
      <Text
        variant={textVariantsEnum.Text_md}
        fontWeight={fontWeightEnum.Normal}
      >
        In order to change subscription plan, your current subscription will be
        cancelled and a new subscription will be created with the new plan.
      </Text>
      <Text
        variant={textVariantsEnum.Text_sm}
        fontWeight={fontWeightEnum.Normal}
      >
        Billing cycle will change as per the new subscription plan.
      </Text>
      <Text
        variant={textVariantsEnum.Text_sm}
        fontWeight={fontWeightEnum.Normal}
        color={'gray-500'}
      >
        Refund will be initiated for the cancelled subscription.
      </Text>
      <div className={styles.buttonsContainer}>
        <Button
          variant={buttonVariants.secondary}
          text="Cancel"
          onClick={onClose}
        />
        <Button
          variant={buttonVariants.primary}
          text="Proceed"
          onClick={onConfirm}
        />
      </div>
    </div>
  );
};
